import { useLang } from '@/i18n';
import EfFootNotes from '@elem/ui/ef-foot-notes';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('dp3.landing.EU12');
    const { locale } = useRouter();

    const configs = {
        text: 'text',
        langKey: 'dp3.landing.EU12',
        links:
            locale === 'ph' ? [t('a1'), t('a2'), t('a3'), t('a4'), t('a5')] : [t('a1'), t('a2'), t('a3'), t('a4'), t('a5'), t('a6'), t('a7'), t('a8'), t('a9')],
        emails: [t('mail1'), t('mail2')],
    };

    return (
        <div className={`${styles.TheComp} GtmModuleData-section`} data-section-id={'dp3-EU12'} data-section-title={'dp3-EU12'} id="footer-tc-id">
            <EfFootNotes {...configs} />
            <EfSpec className="spec-x" />
        </div>
    );
}
